// Application routes for the BHA frontend

export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  LPA_TEST: '/lpa-test',
  VOLUNTEER: '/volunteer',
  VOLUNTEER_SUCCESS: '/volunteer-success',
  PUBLIC_BOOKING: '/book-appointment',
  PUBLIC_BOOKING_CONFIRMATION: '/book-appointment/:confirmationCode',
  PUBLIC_EVENTS: '/public-events',
  
  // Protected routes
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  BUS_SCREENING: '/bus-screening',
  HISTORY: '/screening-history',

  // Admin routes
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_USERS: '/admin/users',
  ADMIN_REPORTS: '/admin/reports',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_ANALYTICS_WAIT_TIMES: '/admin/analytics/wait-times',
  ADMIN_ANALYTICS_HEALTH_OUTCOMES: '/admin/analytics/health-outcomes',
  ADMIN_ANALYTICS_IMPACT: '/admin/analytics/impact',
  ADMIN_ANALYTICS_OPERATIONS: '/admin/analytics/operations',
  ADMIN_ANALYTICS_EVENTS: '/admin/analytics/events',
  ADMIN_ANALYTICS_POPULATION: '/admin/analytics/population',
  ADMIN_ANALYTICS_VOLUNTEERS: '/admin/analytics/volunteers',
  ADMIN_ANALYTICS_BOOKING: '/admin/analytics/booking',
  ADMIN_ANALYTICS_REPORTS: '/admin/analytics/reports',
  ADMIN_EVENTS: '/admin/events',
  ADMIN_EVENT_DETAILS: '/admin/events/:id',
  ADMIN_ALL_MEMBERS: '/admin/all-members',
  ADMIN_PATIENT_QUEUE: '/admin/member-queue',
  ADMIN_SCREENING_ENTRY: '/admin/screening-entry/:patientId',
  ADMIN_PATIENT_EDIT: '/admin/patient-edit/:patientId',
  ADMIN_MEMBER_RECORD_EDIT: '/admin/member-records/:patientId/edit',
  ADMIN_CASE_MANAGEMENT: '/admin/case-management',
  ADMIN_INBOX: '/admin/inbox',
  ADMIN_AUDIT_LOGS: '/admin/audit-logs',
  ADMIN_VOLUNTEER_REGISTRATIONS: '/admin/volunteer-registrations',
  ADMIN_CALL_LOGS: '/admin/call-logs',
  ADMIN_PULSE: '/admin/pulse',
  ADMIN_FORM_CONFIG: '/admin/form-config',
  ADMIN_DATA_IMPORT: '/admin/data-import',
  ADMIN_BACKEND_LOGS: '/admin/backend-logs',

  // On-Demand Healthcare
  ADMIN_ONDEMAND_STORAGE: '/admin/ondemand/storage-units',
  ADMIN_ONDEMAND_HCWS: '/admin/ondemand/hcws',
  ADMIN_ONDEMAND_EVENTS: '/admin/ondemand/events',
  ADMIN_ONDEMAND_PATIENTS: '/admin/ondemand/patients',
  ADMIN_ONDEMAND_PAYOUTS: '/admin/ondemand/payouts',
  ADMIN_ONDEMAND_ORDERS: '/admin/ondemand/orders',
  ADMIN_ONDEMAND_STATUS: '/admin/ondemand/status-board',
  ADMIN_ONDEMAND_REQUESTS: '/admin/ondemand/client-requests',

  // Surveys
  ADMIN_SURVEYS: '/admin/surveys',
  ADMIN_SURVEY_BUILDER_NEW: '/admin/surveys/new',
  ADMIN_SURVEY_BUILDER: '/admin/surveys/:id/edit',
  ADMIN_SURVEY_RESPONSES: '/admin/surveys/:id/responses',
  ADMIN_SURVEY_PREVIEW: '/admin/surveys/:id/preview',

  // Email Campaigns
  ADMIN_EMAIL_CAMPAIGNS: '/admin/campaigns',
  ADMIN_EMAIL_CAMPAIGN_BUILDER_NEW: '/admin/campaigns/new',
  ADMIN_EMAIL_CAMPAIGN_BUILDER: '/admin/campaigns/:id/edit',
  ADMIN_EMAIL_CAMPAIGN_ANALYTICS: '/admin/campaigns/:id/analytics',
  ADMIN_EMAIL_TEMPLATES: '/admin/email-templates',
  ADMIN_EMAIL_AUTOMATIONS: '/admin/email-automations',
  ADMIN_EMAIL_AUTOMATION_BUILDER_NEW: '/admin/email-automations/new',
  ADMIN_EMAIL_AUTOMATION_BUILDER: '/admin/email-automations/:id/edit',
  ADMIN_INSURANCE_ENROLLMENTS: '/admin/insurance-enrollments',

  // Public Survey Hosting
  PUBLIC_SURVEY: '/s/:slug',
  PUBLIC_INSURANCE: '/insurance',
  DELETE_ACCOUNT: '/delete-account',

  // Public
  PATIENT_COMPLETE: '/complete/:token',
  PATIENT_RESULTS: '/results/:token',

  // Error routes
  NOT_FOUND: '/404',
  SERVER_ERROR: '/500'
};

export default ROUTES;